import { render, staticRenderFns } from "./RatePacients.vue?vue&type=template&id=65f60aef&scoped=true&"
import script from "./RatePacients.vue?vue&type=script&lang=js&"
export * from "./RatePacients.vue?vue&type=script&lang=js&"
import style0 from "./RatePacients.vue?vue&type=style&index=0&id=65f60aef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f60aef",
  null
  
)

export default component.exports